import React from 'react'

const FLAGS = {
  pt: '\u{1F1E7}\u{1F1F7}',
  en: '\u{1F1FA}\u{1F1F8}',
  es: '\u{1F1EA}\u{1F1F8}'
}

// Bandeira do locale como emoji unicode. Substituiu 2810 linhas de SVG
// inline que pesavam ~135 KB no bundle só para renderizar 3 ícones.
export default function getIcon(locale) {
  const flag = FLAGS[locale] || FLAGS.en
  return (
    <span
      role="img"
      aria-label={locale}
      style={{ fontSize: 24, lineHeight: 1 }}
    >
      {flag}
    </span>
  )
}
